<template>
  <section class="section" id="jobs">
    <br>
    <div class="container">
      <img class="b-title" :src="require(`../assets/titles/${$i18n.locale}/jobs.jpg`)" alt="Jobs">
      <b-divider></b-divider>
      <br>
      <br>
      <div class="columns">
        <div class="column box b-team">
          <strong>{{$t('team.title')}}</strong>
          <br>
          <br>
          <p>{{$t('team.subtitle')}}</p>
          <br>
          <div class="content">
            <ul>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.1')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.2')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.3')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.4')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.5')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.6')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('team.7')}}
              </li>
            </ul>
          </div>
          <p>Bewerbungen werden nur in elektronischer Form (bewerbung@bringe.com) entgegengenommen.</p>
          <br>
          <b-jobs-openings></b-jobs-openings>
          <br>
        </div>
        <div class="column box b-azubi">
          <strong>{{$t('apprentice.title')}}</strong>
          <br>
          <br>
          <p>{{$t('apprentice.a')}}</p>
          <br>
          <p>{{$t('apprentice.b')}}</p>
          <br>
          <p>{{$t('apprentice.c')}}</p>
          <br>
          <div class="content">
            <ul>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('apprentice.1')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('apprentice.2')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('apprentice.3')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('apprentice.4')}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BJobsOpenings from '@/views/BJobsOpenings.vue';
import BDivider from '@/components/BDivider.vue';

export default {
  name: 'BJobs',
  components: {
    BJobsOpenings,
    BDivider,
  },
}
</script>

<style lang="scss" scoped>

  .b-title {
    width: 80px;
  }

  ul {
    list-style: none !important;
    margin: 0 !important;
  }

  .b-azubi {
    margin-bottom: 1.5em;
    margin-left: .5em;
    padding: 2em;
  }

  .b-team {
    margin-right: .5em;
    padding: 2em;
  }

  .container {
    padding-right: .75em;
    padding-left: .75em;
  }
</style>
